import '../App.css';
import { Web3Provider } from '@ethersproject/providers';
import { InjectedConnector } from '@web3-react/injected-connector';
import { useWeb3React } from '@web3-react/core';
import { useState, useEffect, useRef } from 'react';
import { ethers } from 'ethers';
const entanglerAbi = require('../entanglerAbi.json');

var MintWidget = (props) => {
  const { account, activate, active, library: provider } = useWeb3React();
  const injected = new InjectedConnector();
  const entanglerAddress = '0xDC08aa5d94AC05F73DdB1F29a13C1b6e9c384980';
  const amountInput = useRef(null);

  let [entangler, setEntangler] = useState();
  let [amount, setAmount] = useState(1);
  let [unitPrice] = useState(0.01);
  let [cost, setCost] = useState(0.01);
  let [displayIncorrectAmountText, setDisplayIncorrectAmountText] = useState(false);

  useEffect(() => {
    if (amountInput.current && !(amountInput.current.value === '' && amount === 0)) {
      amountInput.current.value = amount;
    }
  });

  const calcCost = (n) => Math.round(n * unitPrice * 10000) / 10000;
  const plus = () => { setAmount(a => a + 1); setCost(calcCost(amount + 1)); };
  const minus = () => { if (amount > 0) { setAmount(a => a - 1); setCost(calcCost(amount - 1)); } };

  const inputAmountChange = (e) => {
    const v = e.target.value;
    if (v === '' || v < 0) { setAmount(0); setCost(0); }
    else { setAmount(parseInt(v)); setCost(calcCost(parseInt(v))); }
  };

  async function connect() {
    try {
      await activate(injected);
      setTimeout(() => {
        props.onSetSigner(provider.getSigner());
        props.onSetEntangler(new ethers.Contract(entanglerAddress, entanglerAbi, provider.getSigner()));
        props.onSetUserAccount(account);
      }, 60000);
    } catch(e) { console.log('Error connecting', e); }
  }

  async function mint() {
    const v = amountInput.current?.value || '';
    if (amount > 0 && !v.includes('-') && !v.includes('.') && !v.includes('e')) {
      if (active) {
        props.onWaitingForUserToConfirm(true);
        const signer = provider.getSigner();
        const tmp = entangler || new ethers.Contract(entanglerAddress, entanglerAbi, signer);
        setEntangler(tmp);
        props.onSetEntangler(new ethers.Contract(entanglerAddress, entanglerAbi, signer));
        props.onMintInProgress(true);
        try {
          const tx = await tmp.mint(account, 0, amount, { value: ethers.utils.parseEther(cost.toString()) });
          props.onWaitingForUserToConfirm(false);
          props.onWaitingForTxToConfirm(true);
          const txLogs = await tx.wait();
          props.onWaitingForTxToConfirm(false);
          props.onWaitingForRoyaltyGeneration(true);

          let mandates;
          try { mandates = await tmp.getTokenTypeMandates(0); } catch(e) {}

          const nftsMinted = txLogs.events.map(ev => ev.args.id.toNumber());
          const nftsMintedObj = {};
          const nftsReadyToCommit = [];
          const nftsMissingRoyalties = [];

          for (const nft of nftsMinted) {
            setTimeout(async () => {
              try {
                nftsMintedObj[nft] = await getNftRoyalties(nft);
                for (let j = 0; j < nftsMintedObj[nft].length; j++) {
                  if (typeof nftsMintedObj[nft][j] === 'undefined') {
                    try { nftsMintedObj[nft][j] = await retryRetrieveRoyalty(nft, j); } catch(e) {}
                  }
                }
                nftsMintedObj[nft].mandates = mandates;
                const ready = nftsMintedObj[nft].slice(0, 4).every(r => typeof r !== 'undefined');
                if (!ready) await lastDitchRetry(nft, nftsMintedObj);
                nftsReadyToCommit.push(nft);
                if (!ready) nftsMissingRoyalties.push(nft);
                if (nftsReadyToCommit.length === nftsMinted.length) {
                  checkForMissingRoyalties(nftsMissingRoyalties);
                  props.onMintInProgress(false);
                  props.onWaitingForRoyaltyGeneration(false);
                  props.updateNfts(nftsMintedObj);
                }
              } catch(e) { console.log(e); }
            }, 60000);
          }
        } catch(e) {
          props.onMintInProgress(false);
          props.onWaitingForUserToConfirm(false);
        }
      }
    } else {
      setDisplayIncorrectAmountText(true);
      setTimeout(() => setDisplayIncorrectAmountText(false), 4000);
    }
  }

  const getEntangler = () => entangler || new ethers.Contract(entanglerAddress, entanglerAbi, provider.getSigner());

  async function lastDitchRetry(nft, obj) {
    return new Promise(resolve => setTimeout(async () => {
      for (let j = 0; j < obj[nft].length; j++) {
        if (typeof obj[nft][j] === 'undefined') {
          try { obj[nft][j] = await retryRetrieveRoyalty(nft, j); } catch(e) {}
        }
        if (j === obj[nft].length - 1) resolve();
      }
    }, 5000));
  }

  async function retryRetrieveRoyalty(id, idx, count = 0, limit = 10) {
    return new Promise(async (resolve, reject) => {
      try {
        const tx = getEntangler().royalties(id, idx).catch(err => { if (count > limit) reject(err); });
        resolve(await tx);
      } catch(e) { reject(e); }
    });
  }

  async function getNftRoyalties(id) {
    return new Promise(resolve => {
      let results = Array(4);
      for (let i = 0; i < 4; i++) {
        setTimeout(async () => {
          try { results[i] = await entangler.royalties(id, i); } catch(e) {}
          if (i === 3) resolve(results);
        }, 1000);
      }
    });
  }

  async function checkForMissingRoyalties(missing, count = 0) {
    setTimeout(async () => {
      const resArr = [];
      for (const nft of missing) {
        const nftObj = { id: nft, royalties: Array(4) };
        for (let j = 0; j < 4; j++) {
          try {
            nftObj.royalties[j] = await retryRetrieveRoyalty(nft, j, 0, 10);
            if (j === 3) {
              const allSet = nftObj.royalties.every(r => typeof r !== 'undefined');
              if (allSet) {
                resArr.push([nftObj]);
                props.setLatentNfts([...resArr]);
                [1000, 2000, 3000, 4000].forEach(d => setTimeout(() => props.setLatentNfts([...resArr]), d));
              } else {
                checkForMissingRoyalties([nft], count + 1);
              }
            }
          } catch(e) {}
        }
      }
    }, 15000);
  }

  return (
    <>
      {active ? (
        <div className="mint-widget-box">
          <p className="mint-widget-header">Mint</p>
          <div>
            Number of ImpactKeys:
            <button className="minus-btn" onClick={minus}>-</button>
            <input
              type="number"
              className="mint-amount"
              onChange={inputAmountChange}
              onKeyDown={e => e.key === '-' && e.preventDefault()}
              defaultValue={amount}
              ref={amountInput}
            />
            <button className="plus-btn" onClick={plus}>+</button>
          </div>
          <div>
            <div className="mint-cost">Cost: {cost} eth + gas fees</div>
            <button className="mint-btn" onClick={mint}>mint</button>
            {displayIncorrectAmountText && <div className="fade-in">Please enter a valid amount</div>}
          </div>
        </div>
      ) : (
        <button className="connect-btn" onClick={connect}>Connect Wallet</button>
      )}
    </>
  );
};

export default MintWidget;
